import { saveAs } from 'file-saver';
import config from '../config';

const basename = (path: string) => path.split(/[\\/]/).pop();

export default {
  downloadPath(fileName: string, namespace = 'working') {
    return `${config.serverUrl}/api/download/${namespace}/${fileName.replace(/#/g, '%23')}`;
  },

  downloadDataUri(uri: string, name: string) {
    const link = document.createElement('a');
    link.download = name || basename(uri) || '';
    link.href = uri;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  saveAs,
};
